import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// ── Autonomía por canal (Mensajería Etapa 2, 2026-08-20) ─────────────────────
// Por canal y no por cuenta: en WhatsApp cada mensaje cuesta plata y en
// Instagram no, así que no es la misma decisión.

export type AutonomyLevel = 'propose' | 'auto' | 'auto_notify';

export interface ChannelAutonomy {
  platform: string;
  level: AutonomyLevel;
  updatedAt: string | null;
}

const KEY = ['messaging-autonomy'];

export function useMessagingAutonomy() {
  return useQuery<{ channels: ChannelAutonomy[]; levels: AutonomyLevel[] }>({
    queryKey: KEY,
    queryFn: () => api.get('/api/messaging-autonomy'),
    staleTime: 60_000,
  });
}

export function useSetAutonomy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ platform, level }: { platform: string; level: AutonomyLevel }) =>
      api.put<ChannelAutonomy>(`/api/messaging-autonomy/${platform}`, { level }),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: KEY }); },
  });
}
